import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './MobileProductOverlay.css';
import { Api } from "../../BackendApi/api";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";
import MobileCategoryOverlay from "../MobileCategory/MobileCategoryOverlay";

const MobileProductOverlay = ({ onClose, onSave }) => {
  const [categories, setCategories] = useState([]);
  const [showCategoryOverlay, setShowCategoryOverlay] = useState(false); 
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    CategoryId: "",
    ProductName: "",
    Description: "",
    ProductMRP: "",
    ProductSellingPrice: "",
    AllotCoins: "",
    CurrentStock: "",
    ProductImages: [],
  });

  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const categoryRef = useRef(null);

  useEffect(() => {
    if (categoryRef.current) {
      categoryRef.current.focus();
    }
  }, []);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first!",
          type: "warning",
        });
        navigate("/");
        return;
      }

      const res = await axios.post(
        Api.getCategories,
        { limit: 50, Status: "Active" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (
        res.data.status === 0 &&
        (res.data.message === "Invalid AuthToken" ||
          res.data.message === "AuthToken is required")
      ) {
        navigate("/");
        return;
      }

      if (Array.isArray(res.data.data)) {
        const sortedCategories = res.data.data.sort((a, b) =>
          a.CategoryName.localeCompare(b.CategoryName)
        );
        setCategories(sortedCategories);
      }
    } catch (err) {
      console.error("❌ Error fetching categories:", err);
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to fetch categories.",
        type: "error",
      });
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "ProductImages") {
      const fileArray = Array.from(files);
      setFormData({
        ...formData,
        ProductImages: fileArray,
      });
      setPreview(fileArray.map((file) => URL.createObjectURL(file)));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first! Redirecting to login...",
          type: "warning",
        });
        setLoading(false);
        navigate("/");
        return;
      }

      const imagePaths = formData.ProductImages.map(
        (file) => `/images/products/${file.name}`
      );

      const payload = {
        CategoryId: formData.CategoryId,
        ProductName: formData.ProductName,
        Description: formData.Description,
        ProductMRP: Number(formData.ProductMRP),
        ProductSellingPrice: Number(formData.ProductSellingPrice),
        AllotCoins: Number(formData.AllotCoins),
        CurrentStock: Number(formData.CurrentStock),
        ProductImages: imagePaths,
      };

      const res = await axios.post(Api.addProduct, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        res.data.status === 0 &&
        (res.data.message === "Invalid AuthToken" ||
          res.data.message === "AuthToken is required")
      ) {
        navigate("/");
        return;
      }

      setPopup({
        show: true,
        message: res.data.message || "Product added successfully!",
        type: "success",
      });
    } catch (err) {
      console.error("❌ Error adding product:", err);
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to add product",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };


  const handleCategoryAdded = () => {
    fetchCategories();
    setShowCategoryOverlay(false);
  };

  return (
    <>
      <div className="mobile-product-overlay">
        <div className="mobile-product-overlay-content">
          <h2>Add Product</h2>
          <form className="mobile-product-overlay-form" onSubmit={handleSubmit}>
            <label className="full-width">
              Category
              <div className="category-row">
                <select
                  ref={categoryRef}
                  name="CategoryId"
                  value={formData.CategoryId}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Category --</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.CategoryName}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="add-category-btn"
                  onClick={() => setShowCategoryOverlay(true)}
                >
                  +
                </button>
              </div>
            </label>



            <label>
              Product Name
              <input
                type="text"
                name="ProductName"
                value={formData.ProductName}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Description
              <input
                type="text"
                name="Description"
                value={formData.Description}
                onChange={handleChange}
              />
            </label>

            <label>
              MRP
              <input
                type="number"
                name="ProductMRP"
                value={formData.ProductMRP}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Selling Price
              <input
                type="number"
                name="ProductSellingPrice"
                value={formData.ProductSellingPrice}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Coins
              <input
                type="number"
                name="AllotCoins"
                value={formData.AllotCoins}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Current Stock
              <input
                type="number"
                name="CurrentStock"
                value={formData.CurrentStock}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Product Images
              <input
                type="file"
                name="ProductImages"
                accept="image/*"
                multiple
                onChange={handleChange}
              />
            </label>

            {preview.length > 0 && (
              <div className="image-preview-section">
                <p>Preview:</p>
                <div className="preview-images">
                  {preview.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt="Preview"
                      className="preview-img"
                    />
                  ))}
                </div>
              </div>
            )}

            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="save-btn">
                Save
              </button>
            </div>


          </form>
        </div>

        <MobileConfirmPopup
          show={popup.show}
          message={popup.message}
          type={popup.type}
          onClose={handlePopupClose}
        />
      </div>

      {showCategoryOverlay && (
        <MobileCategoryOverlay
          onClose={() => setShowCategoryOverlay(false)}
          onSave={handleCategoryAdded}
        />
      )}
    </>
  );
};

export default MobileProductOverlay;
